import { useState, useEffect } from 'react';
import axios from 'axios';

// Shared fetch for the public artifact catalog.
export function useArtifacts() {
  const [artifacts, setArtifacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/artifacts`);
        if (active) setArtifacts(res.data);
      } catch (err) {
        console.error('Error fetching artifacts', err);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  return { artifacts, loading };
}
